import { render, staticRenderFns } from "./device.vue?vue&type=template&id=19a5240d&scoped=true&"
import script from "./device.vue?vue&type=script&lang=js&"
export * from "./device.vue?vue&type=script&lang=js&"
import style0 from "./device.vue?vue&type=style&index=0&lang=less&"
import style1 from "./device.vue?vue&type=style&index=1&id=19a5240d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5240d",
  null
  
)

export default component.exports